import { requestBuilder } from '../../http/RequestBuilder';
import type { MastraThread } from '../conversational-mm/ConversationalMoneyMap';

const _useGetAdminMastraThread = requestBuilder.query<
    MastraThread | null,
    { mastraThreadId: string | undefined }
>({
    endpoint: ({ mastraThreadId }) =>
        `/api/admin/mastra-threads/${mastraThreadId}`,
    queryKey: ({ mastraThreadId }) => `getAdminMastraThread/${mastraThreadId}`,
});

export const useGetAdminMastraThread = ({
    mastraThreadId,
}: {
    mastraThreadId: string | undefined;
}) => {
    return _useGetAdminMastraThread(
        { mastraThreadId },
        { enabled: mastraThreadId != null },
    );
};
